import { sortWith, ascend, compose, prop } from 'ramda';
import tinycolor from 'tinycolor2';

export const hue = (val: string) => {
  const color = tinycolor(val);

  return color.toHsv().h;
};

export const lum = (val: string) => {
  const color = tinycolor(val);

  return color.toHsl().l;
};

export const output = (val: string) => {
  const color = tinycolor(val);

  return color.toHsv().v;
};

const colorSorting = (selector: ReturnType<typeof prop>, items: Array<Record<'color', string>>) =>
  sortWith([ascend(compose(hue, selector)), ascend(compose(lum, selector)), ascend(compose(output, selector))], items);

export default colorSorting;
